import react, { useEffect } from "react";
import {
  RouterProvider,
  createBrowserRouter,
  Outlet,
  Navigate,
} from "react-router-dom";
import { useAuth } from "./context/authContext";
import { useSelector } from "react-redux";
import { onMessageListener } from "./firebase_services/onMessageListener";
import { isSupported } from "firebase/messaging";
import Swal from "sweetalert2";
import Icons from "./assets/icon";
import { ScrollRestoration, ProtectedRoute, GoogleTagManager } from "./components/index";
import {
  AppliedApplication,
  AppliedJobs,
  Category,
  CategoryList,
  CategoryDetail,
  ChangePassword,
  ContactUs,
  CreateJob,
  Chatmessage,
  Dashboard,
  EmpApplicantsList,
  EmployerRegister,
  EmployerUpdate,
  Events,
  EventDetails,
  FavEvents,
  FavJobs,
  FavNews,
  DashboardEvents,
  Favourites,
  ForgetPassword,
  Gallery,
  GalleryProjects,
  GalleryVideos,
  HireRequest,
  HiringRequests,
  Home,
  JobDetails,
  JobList,
  JobListing,
  JobSave,
  JobUpdate,
  Login,
  MissionSHE,
  MissionSHEDetails,
  News,
  NewsDetails,
  Package,
  PageNotFound,
  PrivacyPolicy,
  Project,
  ProjectDetails,
  Register,
  ReguisterVerifiedOtp,
  ResetPassword,
  ReVerifiedEmailOtp,
  SingleChatMessage,
  SingleTeam,
  Talent,
  TalentDetails,
  TalentNews,
  TalentRegister,
  TalentUpdate,
  Team,
  TermsAndConditions,
  Upgrade,
  UserUpdate,
  VerifiedOtp,
} from "./pages/index";

const Layout = () => (
  <>
    <ScrollRestoration />
    <Outlet />
  </>
);

export const capitalizeFirstWord = (text) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
};
function App() {
  const { isLoggedIn } = useAuth();

  const userData = useSelector((state) => state.app.userData.userData);

  useEffect(() => {
      const checkSupport = async () => {
      const supported = await isSupported();
        if (!supported) {
          console.log("Firebase messaging not supported in this browser");
          alert("Firebase messaging not supported in this browser");
          return;
        }

        startListening();
      };

      checkSupport();
   
    const startListening = () => {
      onMessageListener()
        .then((payload) => {
          const isSuccess = payload.notification?.body
            .toLowerCase()
            .includes("report is ready");
          Swal.fire({
            title: `<span class="custom-toast-title">${capitalizeFirstWord(
              payload.notification?.title
            )}</span>`,
            text: payload.notification?.body,
            iconHtml: `<img src="${
              isSuccess === "error" ? Icons?.onErrorIcon : Icons?.onSuccessIcon
            }" alt="icon" class="custom-toast-icon" />`,
            position: "top-end",
            timer: 5000,
            showCloseButton: true,
            showConfirmButton: false,
            timerProgressBar: true,
            toast: true,
            customClass: {
              popup: "my-toast",
              icon: "no-border",
            },
          });
          startListening();
        })
        .catch((err) => console.error("Failed onMessageListener: ", err));
    };
    startListening();
  }, []);

  

  useEffect(() => {

      const isAndroid = /Android/i.test(navigator.userAgent);
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

      //  console.log("isAndroid", isAndroid, "isIOS", isIOS)
      //  alert("isandroid");
      // alert(isAndroid);
      // alert(" isIOS")
      // alert( isIOS)    
      // alert("localStorage.getItem(gemAppPromptShown)")
      // alert(localStorage.getItem("gemAppPromptShown"))
      // Only show on mobile devices
      if (!isAndroid && !isIOS) return;

      // Prevent showing again
      // if (localStorage.getItem("gemAppPromptShown")) return;

      Swal.fire({
        title: "Open GEM App?",
        text: "For better experience, open in GEM app.",
        // icon: "question",
        showCancelButton: true,
        confirmButtonText: "Open App",
        cancelButtonText: "Stay Here",
        confirmButtonColor: "#DAB55E",
      }).then((result) => {
        localStorage.setItem("gemAppPromptShown", "true");

        if (result.isConfirmed) {
          if (isAndroid) {
            // Try deep link first
            window.location.href = "gem://home";

            // Fallback to Play Store after 2 seconds
            setTimeout(() => {
              window.location.href =
                "https://play.google.com/store/apps/details?id=com.geminc.gem";
            }, 2000);
          } else if (isIOS) {
            window.location.href = "gem://home";

            setTimeout(() => {
              window.location.href =
                "https://apps.apple.com/app/id6755765029";
            }, 2000);
          }
        }
      });
  }, [])

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        { path: "/", element: <Home /> },
        {
          path: "/login",
          element: isLoggedIn ? <Navigate to="/" /> : <Login />,
        },
        {
          path: "/forget-password",
          element: isLoggedIn ? <Navigate to="/" /> : <ForgetPassword />,
        },
        {
          path: "/verified-otp",
          element: isLoggedIn ? <Navigate to="/" /> : <VerifiedOtp />,
        },
        {
          path: "/verified-otp/:id",
          element: isLoggedIn ? <Navigate to="/" /> : <ReguisterVerifiedOtp />,
        },
        {
          path: "/reVerified-otp/:id",
          element: isLoggedIn ? <Navigate to="/" /> : <ReVerifiedEmailOtp />,
        },
        {
          path: "/reset-password",
          element: isLoggedIn ? <Navigate to="/" /> : <ResetPassword />,
        },
        {
          path: "/register",
          element: isLoggedIn ? <Navigate to="/" /> : <Register />,
        },
        { path: "/terms-and-conditions", element: <TermsAndConditions /> },
        { path: "/privacy-policy", element: <PrivacyPolicy /> },
        // { path: "/upgrade", element: (userData?.role === "talent" || userData?.role === "employer" ? <Navigate to="/" /> : isLoggedIn ? <Upgrade /> : <Navigate to="/login" />) },
        {
          path: "/upgrade",
          element: isLoggedIn ? <Upgrade /> : <Navigate to="/login" />,
        },
        {
          path: "/talent-register",
          element: isLoggedIn ? <TalentRegister /> : <Navigate to="/login" />,
        },
        {
          path: "/talent-update",
          element:
            userData?.role === "talent" ? (
              <TalentUpdate />
            ) : (
              <Navigate to="/login" />
            ),
        },
        {
          path: "/hiring-requests",
          element:
            userData?.role === "talent" ? (
              <HiringRequests />
            ) : (
              <Navigate to="/login" />
            ),
        },
        {
          path: "/employer-register",
          element: isLoggedIn ? <EmployerRegister /> : <Navigate to="/login" />,
        },
        {
          path: "/employer-update",
          element:
            userData?.role === "employer" ? (
              <EmployerUpdate />
            ) : (
              <Navigate to="/login" />
            ),
        },
        {
          path: "/user-update",
          element: isLoggedIn ? <UserUpdate /> : <Navigate to="/login" />,
        },
        {
          path: "/change-password",
          element: isLoggedIn ? <ChangePassword /> : <Navigate to="/login" />,
        },
        {
          path: "/create-job",
          element:
            userData?.role === "employer" ? (
              <CreateJob />
            ) : (
              <Navigate to="/login" />
            ),
        },
        {
          path: "/update-job",
          element:
            userData?.role === "employer" ? (
              <JobUpdate />
            ) : (
              <Navigate to="/login" />
            ),
        },
        {
          path: "/empjob-listing",
          element:
            userData?.role === "employer" ? (
              <JobList />
            ) : (
              <Navigate to="/login" />
            ),
        },
        {
          path: "/emp-applicants-list",
          element:
            userData?.role === "employer" ? (
              <EmpApplicantsList />
            ) : (
              <Navigate to="/login" />
            ),
        },
        { path: "/talent", element: <Talent /> },
        {
          path: "/talent/:id",
          element: !isLoggedIn ? (
            <Navigate to="/login" />
          ) : (
            <TalentDetails />
          ),
        },
        { path: "/packages", element: <Package /> },
        { path: "/event", element: <Events /> },
        { path: "/event-details/:id", element: <EventDetails /> },
        { path: "/project", element: <Project /> },
        { path: "/project-details/:id", element: <ProjectDetails /> },
        { path: "/missionShe", element: <MissionSHE /> },
        { path: "/missionShe-details/:id", element: <MissionSHEDetails /> },
        { path: "/news", element: <News /> },
        { path: "/news-details/:id", element: <NewsDetails /> },
        { path: "/team", element: <Team /> },
        { path: "/single-team/:id", element: <SingleTeam /> },
        { path: "/category", element: <Category /> },
        { path: "/category-detail", element: <CategoryDetail /> },
        { path: "/category-list", element: <CategoryList /> },
        { path: "/contact-us", element: <ContactUs /> },
        {
          path: "/job-details/:id",
          element: (
            <ProtectedRoute>
              <JobDetails />
            </ProtectedRoute>
          ),
        },
        { path: "/job-listing", element: <JobListing /> },
        {
          path: "/job-save",
          element: !isLoggedIn ? (
            <Navigate to="/login" />
          ) : userData?.role === "fan" ? (
            <Navigate to="/upgrade" />
          ) : (
            <JobSave />
          ),
        },
        {
          path: "/applied-application",
          element: isLoggedIn ? (
            <AppliedApplication />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "/dashboard",
          element: isLoggedIn ? <Dashboard /> : <Navigate to="/login" />,
        },
        {
          path: "/dashboard-news",
          element: isLoggedIn ? <TalentNews /> : <Navigate to="/login" />,
        },
        {
          path: "/chat",
          element: isLoggedIn ? <Chatmessage /> : <Navigate to="/login" />,
        },
        {
          path: "/favourites",
          element: isLoggedIn ? <Favourites /> : <Navigate to="/login" />,
        },
        {
          path: "/my-gallery",
          element: isLoggedIn ? <Gallery /> : <Navigate to="/login" />,
        },
        {
          path: "/talent-add-projects",
          element: isLoggedIn ? <GalleryProjects /> : <Navigate to="/login" />,
        },
        {
          path: "/talent-add-videos",
          element: isLoggedIn ? <GalleryVideos /> : <Navigate to="/login" />,
        },
        {
          path: "/favourites-jobs",
          element: isLoggedIn ? <FavJobs /> : <Navigate to="/login" />,
        },
        {
          path: "/favourites-events",
          element: isLoggedIn ? <FavEvents /> : <Navigate to="/login" />,
        },
        {
          path: "/dashboard-events",
          element: isLoggedIn ? <DashboardEvents /> : <Navigate to="/login" />,
        },
        {
          path: "/favourites-news",
          element: isLoggedIn ? <FavNews /> : <Navigate to="/login" />,
        },
        {
          path: "/applied-jobs",
          element: isLoggedIn ? <AppliedJobs /> : <Navigate to="/login" />,
        },
        {
          path: "/employer-hire-request",
          element: isLoggedIn ? <HireRequest /> : <Navigate to="/login" />,
        },
        {
          path: "/chat/:id",
          element: isLoggedIn ? (
            <SingleChatMessage />
          ) : (
            <Navigate to="/login" />
          ),
        },
        { path: "*", element: <PageNotFound /> },
      ],
    },
  ]);
  return (
    <>
      <GoogleTagManager />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
